import { t } from '@/i18n/utils'

/**
 * Book 页面公共配置
 * 所有品牌共享的文案和资源
 */

export const commonTexts = {
  get completed() { return t('Completed') },
  get ongoing() { return t('OnGoing') },
  get catalogue() { return t('Catalogue') },
  get latestChapter() { return t('LatestChapter') },
  get readFirstChapter() { return t('ReadFirstChapter') },
  get startReading() { return t('StartReading') },
  get continueReading() { return t('ContinueReading') },
  get noChapters() { return t('NoChapters') },
  get booksNotExist() { return t('BooksDontExist') },
  get loading() { return `${t('Loading')}...` },

  get bookIntroduce() { return t('WorkIntroduction') },
  get chapters() { return t('Chapters') },

  get bookshelfSuccess() { return t('bookshelfSuccess') },
  get bookshelfError() { return t('bookshelfError') },

}
